module.exports = __webpack_public_path__ + "static/media/minus-ui-ux-svgrepo-com.291f9a37.svg";